import { Component, Input, Output, EventEmitter, OnInit } from '@angular/core';
import { CommunicationDTO, CommunicationDirectionType, CommunicationStatusType, ResultTypeDTO, ValidationResultDTO } from '../../api/plyca-dtos-v2';
import { ConfirmationService, MenuItem } from 'primeng-lts/api';
import { PlycaDataService } from '../../../services/plyca.service';
import { Configuration } from '../../conf/app.constants';
import { WaitLoadingService } from '../../components/common/waitLoading/wait-loading.service';
import { Router } from '@angular/router';
import { finalize, filter, tap, catchError, map } from 'rxjs/operators';
import { TranslateService } from '@ngx-translate/core';
import { BaseComponent } from '../../components/common/baseComponent/base.component';
import { PlycaErrorHandler } from '../../../http/PlycaErrorHandler';
import { Observable, of, pipe, throwError } from 'rxjs';

@Component({
  selector: 'communication-actions',
  templateUrl: './commmunication.actions.template.html'
})
export class CommunicationActionsComponent extends BaseComponent implements OnInit {


  @Input()
  editable: boolean;
  @Input()
  permitecopia: boolean;
  @Input()
  communication: CommunicationDTO;
  @Input()
  perfilvalido: boolean;
  @Input()
  canalactivo: boolean;
  @Output()
  deleted = new EventEmitter<boolean>(false);

  constructor(private plycaService: PlycaDataService,
    private configuration: Configuration,
    private waitService: WaitLoadingService,
    public translateService: TranslateService,
    private plycaErrorHandler: PlycaErrorHandler,
    private confirmationService: ConfirmationService,
    private router: Router) {
    super();
  }

  ngOnInit(): void {
  }

  public getMenuItems(dto: CommunicationDTO): MenuItem[] {
    let actions = new Array<MenuItem>();
    // ver
    let view = {} as MenuItem;
    view.label = this.translateService.instant('General.view');
    view.icon = 'fas fa-eye';
    view.command = (event) => {
      this.viewDetail();
    }
    actions.push(view);
    if (dto.status.type === CommunicationStatusType.EDITING) {
      this.editable = true;


      // delete

      /* Validaciones del applet
        1. Situacion 0 = Canal Arrancado
        2. jButtonBorrar.setEnabled(isPerfilValido);
      */
      let deleteComm = {} as MenuItem;
      deleteComm.label = this.translateService.instant('General.delete');
      deleteComm.icon = 'fas fa-trash';
      deleteComm.command = (event) => {
        this.delete();
      }
      actions.push(deleteComm);
    }





    if (this.permitecopia && this.communication.direction === CommunicationDirectionType.OUT) {
      // copiar
      let copy = {} as MenuItem;
      copy.label = this.translateService.instant('General.copy');
      copy.icon = 'far fa-copy';
      copy.command = (event) => {
        this.copy();
      }
      actions.push(copy)
    }

    return actions;
  }

  public viewDetail(): void {
    this.router.navigate(['communications', this.communication.identifier])
  }

  public editDetail(communication: CommunicationDTO = this.communication): void {
    this.router.navigate(['communications', communication.identifier], { queryParams: { edit: true } });
  }

  public copy(): void {
    this.waitService.startWaiting();
    this.subscribe(this.plycaService
      .execAction(
        this.configuration.COMMUNICATIONS_SERVICE_URL,
        this.communication.identifier,
        'COMMUNICATION_CLONE'
      )
      .pipe(
        finalize(() => this.waitService.cancelWaiting())
      ),
      (result: any) => {
        let copiedComm: CommunicationDTO;
        if (result) {
          if ('OK' === result.identifier) {
            if (result.objectResult) {
              copiedComm = result.objectResult;
            }
          }
        }
        if (copiedComm) {
          this.editDetail(copiedComm);
        }
      });
  }

  public delete(): void {


    this.confirmationService.confirm({
      message: this.translateService.instant('Forms.table.deleteRow'),
      acceptLabel: this.translateService.instant('General.yes'),
      rejectLabel: this.translateService.instant('General.no'),
      accept: () => {
        let patchedCommunication = new CommunicationDTO();
        patchedCommunication.identifier = this.communication.identifier;
        patchedCommunication.deleted = true;
        patchedCommunication.class = this.communication.class;
        this.waitService.startWaiting();
        this.subscribe(this.plycaService.patch(this.configuration.COMMUNICATIONS_SERVICE_URL, patchedCommunication, 'Delete')
          .pipe(
            finalize(() => this.waitService.cancelWaiting())
          ),
          () => {
            this.deleted.emit(true);
          },
          (error) => {
            this.plycaErrorHandler.showServerError(error);
          });
      }
    });

  }


  public updateActions(items: MenuItem[]): Observable<MenuItem[]> {

    // COMMUNICATION.update.ALLOWED
    // cambiar la acción a ejecutar
    // en la propiedad state del objeto MenuItem, el componente del menú de acciones establece dos propiedades
    // 1. action: Contiene los datos de la acción a ejecutar
    // 2. dto: Contiene los datos del objeto sobre el que se debe ejecutar la acción
    /*
    const correctAction = items.find((action: MenuItem) => action.state?.action?.identifier === 'CORRECT_DOCUMENT')
    if (correctAction) {
      correctAction.command = () => this.ejecutaAccion(correctAction.state?.dto)
    }*/
    // añadir item


    /* Validaciones del applet
1.Situacion 0 = Canal Arrancado
2.jButtonModificar.setEnabled(isPerfilValido
   && permiteModificar(notificacion));

boolean isPerfilValido = !__consulta && NotificacionesUtil.puedeGestionarComunicacion();
permiteModificar -> COMMUNICATION.update.ALLOWED
*/

    // this.editable comprueba las dos primeras condiciones
    // falta la última condición    permiteModificar -> COMMUNICATION.update.ALLOWED


    if (this.editable) {

      return this.plycaService.validate(this.configuration.COMMUNICATIONS_SERVICE_URL + '',
        'AllowModificar',
        this.communication
      ).pipe(
        map((validation: ValidationResultDTO) => {
          if (validation?.result === 'OK') {
            items = items.filter(i => i.separator === undefined || !i.separator);
            // editar
            items.push({
              label: this.translateService.instant('General.edit'),
              icon: 'fas fa-pencil-alt',
              command: () => this.editDetail()
            });
            // items.push({ label: 'Mi nueva acción', command: () => console.log('Hola') });


          }
          return items

        }),
        catchError((error: any) => throwError(error)),
        finalize(() => {

          this.waitService.cancelWaiting();

        })
      );
    } else {
      return of(items)
    }

  }
}
